/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { getSystemAgentRoles, putSystemAgentRoles } from '@/service/systemControl'
import RoleAddMemberForm from './RoleAddMemberForm'

/**
 * 解析 GET /system/agents/{id}/roles 返回体（与 AgentAssignRolesForm 行为对齐）
 * @returns {string[]}
 */
function parseRoleIdsFromAgentRolesResponse(data) {
  if (data == null) return []
  if (Array.isArray(data)) {
    if (data.length === 0) return []
    const first = data[0]
    if (first != null && typeof first === 'object' && 'id' in first) {
      return data.map((r) => String(r.id)).filter((id) => id !== '')
    }
    return data.map((x) => String(x)).filter((id) => id !== '')
  }
  if (typeof data === 'string' && data.trim() !== '') {
    return data
      .split(',')
      .map((s) => s.trim())
      .filter((id) => id !== '')
  }
  if (typeof data === 'object') {
    if (typeof data.roleIds === 'string' && data.roleIds.trim() !== '') {
      return data.roleIds
        .split(',')
        .map((s) => s.trim())
        .filter((id) => id !== '')
    }
    if (Array.isArray(data.roleIds)) {
      return data.roleIds.map((id) => String(id)).filter((id) => id !== '')
    }
    if (Array.isArray(data.roles)) {
      return data.roles.map((r) => String(r.id)).filter((id) => id !== '')
    }
  }
  return []
}

class RoleAddMemberModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    record: PropTypes.object.isRequired,
    /** 门店 id → 名称 Map，与角色列表列展示一致 */
    storeNameById: PropTypes.object,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    baseProps: {}
  }

  /** 从该员工系统角色中移除当前角色（全量替换为不含本 roleId 的列表） */
  removeMemberFromRole = async (agentIdRaw) => {
    const { onSuccess, record } = this.props
    const roleId = record?.id
    const agentId =
      agentIdRaw != null && agentIdRaw !== '' ? String(agentIdRaw).trim() : ''
    if (roleId == null || roleId === '' || agentId === '') {
      message.error('参数不完整')
      throw new Error('参数不完整')
    }
    try {
      const res = await getSystemAgentRoles(agentId)
      const existing = parseRoleIdsFromAgentRolesResponse(res?.data)
      const rid = String(roleId)
      const next = existing.map((id) => String(id)).filter((id) => id !== rid)
      await putSystemAgentRoles(agentId, { roleIds: next.join(',') })
      message.success('已从本角色移除')
      if (typeof onSuccess === 'function') {
        onSuccess()
      }
    } catch (e) {
      const msg =
        e?.response?.data?.msg ||
        e?.response?.data?.message ||
        e?.message ||
        e?.msg ||
        '移除失败'
      message.error(typeof msg === 'string' ? msg : '移除失败')
      throw e
    }
  }

  /** 为员工追加当前角色（与原弹窗确定提交逻辑一致） */
  addMemberToRole = async (agentIdRaw) => {
    const { onSuccess, record } = this.props
    const roleId = record?.id
    const agentId =
      agentIdRaw != null && agentIdRaw !== '' ? String(agentIdRaw).trim() : ''
    if (roleId == null || roleId === '' || agentId === '') {
      message.error('缺少参数')
      throw new Error('缺少参数')
    }
    try {
      const res = await getSystemAgentRoles(agentId)
      const existing = parseRoleIdsFromAgentRolesResponse(res?.data)
      const set = new Set(existing.map((id) => String(id)))
      set.add(String(roleId))
      const roleIdsStr = [...set].join(',')
      await putSystemAgentRoles(agentId, { roleIds: roleIdsStr })
      message.success('已加入本角色')
      if (typeof onSuccess === 'function') {
        onSuccess()
      }
    } catch (e) {
      const msg =
        e?.response?.data?.msg ||
        e?.response?.data?.message ||
        e?.message ||
        e?.msg ||
        '保存失败'
      message.error(typeof msg === 'string' ? msg : '保存失败')
      throw e
    }
  }

  /** 单屏即时操作：添加、移除已在表单内完成；此按钮仅关闭弹窗 */
  handleOk = async () => {}

  render() {
    const { children, baseProps, record, storeNameById, width: widthProp } = this.props
    const width = widthProp !== undefined ? widthProp : 560
    const title = `成员管理${record?.name != null && record.name !== '' ? ` — ${record.name}` : ''}`

    return (
      <WrappedModal
        children={children}
        title={title}
        width={width}
        destroyOnClose
        baseComponent={<RoleAddMemberForm />}
        baseProps={{
          ...baseProps,
          roleRecord: record,
          storeNameById: storeNameById || null,
          onRemoveMember: this.removeMemberFromRole,
          onAddMember: this.addMemberToRole
        }}
        onOk={this.handleOk}
        okText="完成"
      />
    )
  }
}

export default RoleAddMemberModal
